module.exports = __webpack_public_path__ + "static/media/rRNAs_heatmap.75dce042.png";